const productCategory = [
  { id: 1, label: "Tai nghe Airpods", value: "airpodes" },
  { id: 2, label: "Máy ảnh", value: "camera" },
  { id: 3, label: "Tai nghe", value: "earphones" },
  { id: 4, label: "Điện thoại di động", value: "mobiles" },
  { id: 5, label: "Chuột", value: "Mouse" },
  { id: 6, label: "Máy in", value: "printers" },

  { id: 7, label: "Tủ lạnh", value: "refrigerator" },
  { id: 8, label: "Loa", value: "speakers" },
  { id: 9, label: "Máy cắt", value: "trimmers" },
  { id: 10, label: "Tivi", value: "televisions" },
  { id: 11, label: "Đồng hồ", value: "watches" },
];

export default productCategory;
